import { render, staticRenderFns } from "./CrawlJobLogsDialog.vue?vue&type=template&id=588c371b&scoped=true&"
import script from "./CrawlJobLogsDialog.vue?vue&type=script&lang=ts&"
export * from "./CrawlJobLogsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588c371b",
  null
  
)

export default component.exports